import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorKey } from '../app-active-error/ErrorKey';
import StandardError from '../app-active-error/StandardError';
import { useLoginRedirect } from '../signup-completed-redirection/useLoginRedirect';

const UnauthedPartnerUserErrorView = () => {
  const {
    redirectToLogin
  } = useLoginRedirect();

  const handleButtonClick = () => {
    redirectToLogin();
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.UnauthedPartnerUserError,
    handleButtonClick: handleButtonClick
  });
};

export default UnauthedPartnerUserErrorView;